<template>
  <div class="video-introduce">
    <h3>Quản lý video giới thiệu page môi trường làm việc</h3>
    <a-radio-group v-model="video_type" :default-value="1" @change="onChangeVideoType">
      <a-radio :value="1">
        Upload video
      </a-radio>
      <a-radio :value="2">
        Sử dụng link youtube
      </a-radio>
    </a-radio-group>
    <a-row class="mt-30" :gutter="24">
      <a-col :span="12" v-if="video_type === 1">
        <input type="file" accept="video/mp4,video/x-m4v,video/*" @change="onChangeVideoUpload" />
      </a-col>
      <a-col :span="12" v-else>
        <a-input v-model="youtubeLink" @change="onChangeYoutubeLink" placeholder="Nhập link youtube ..." />
      </a-col>
    </a-row>

    <h4 class="mt-30">Video hiện tại</h4>
    <a-row class="mt-10">
      <a-col :span="12">
        <iframe width="100%" height="auto" :src="currentVideoUrl" style="aspect-ratio: 16 / 9; object-fit: contain"
          frameborder="0" />
      </a-col>
    </a-row>

    <a-row type="flex" justify="start" class="mt-40">
      <a-button :disabled="!form.video" type="primary" @click="handleSubmit">Cập nhật video</a-button>
    </a-row>
  </div>
</template>

<script>
import { fetch, update, create, removeFile } from '@/services/landing-page/career/career-introduce'
export default {
  name: 'VideoIntroduce',
  data() {
    return {
      video_type: 1,
      youtubeLink: '',
      form: {
        id: null,
        type: 4,
        post_type: 2,
        video: null
      },

      currentVideoUrl: '',
      currentVideoId: null
    }
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const params = {
          type: this.form.type,
          post_type: this.form.post_type,
          post_type_video: 1,
          per_page: 1
        }
        const response = await fetch(params)
        if (response.data.data.length) {
          this.form.id = response.data.data[0].id
          if (response.data.data[0].recruitment_introduce_file.length) {
            this.currentVideoId = response.data.data[0].recruitment_introduce_file[0].id
            this.currentVideoUrl = `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${response.data.data[0].recruitment_introduce_file[0].url_file}`
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      try {
        let formData = new FormData()

        formData.append('title', 'ádas')
        formData.append('description', 'sadsad')
        formData.append('content', 'ádsa')
        formData.append('active', 1)
        formData.append('video', this.form.video)
        formData.append('video_type', this.video_type)
        formData.append('post_type', this.form.post_type)
        formData.append('type', this.form.type)

        if (this.form.id) {
          formData.append('_method', 'PUT')
          if (this.currentVideoId && this.form.video) {
            await removeFile(this.currentVideoId)
          }
          await update(this.form.id, formData)
        } else {
          await create(formData)
        }
        if (response.status == 1) {
          const message = this.form.id
            ? "Cập nhật thành công."
            : "Thêm mới thành công.";
          this.$notification.success({
            message: "Thành công",
            description: message,
          });
        } else {
          this.$notification.error({
            message: "Thất bại",
            description: response.errors[0],
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    onChangeVideoType() {
      this.form.video = null
    },

    onChangeVideoUpload(e) {
      let file = e.target.files[0];
      this.form.video = file
      let blobURL = URL.createObjectURL(file);
      document.querySelector("iframe").style.display = 'block';
      this.currentVideoUrl = blobURL
    },

    onChangeYoutubeLink() {
      const link = this.youtubeLink.replace('watch?v=', 'embed/').split('&')[0]
      this.form.video = link
      document.querySelector("iframe").style.display = 'block';
      this.currentVideoUrl = link
    }
  }
}
</script>

<style lang="scss" scoped></style>